import { Record } from 'immutable';
import { unionBy, isEmpty } from 'lodash';
import moment from 'moment';

import {
  CLEAR_BARBER_AVAILABILITY,
  RECEIVE_BARBER_AVAILABILITY,
  REQUEST_BARBER_AVAILABILITY,
  SET_ACTIVE_DAY,
  SET_ACTIVE_TIME,
  SET_ACTIVE_TIME_BARBER,
} from '../constants';
import config from '../../config';

const InitialState = Record({
  activeDay: moment().format(config.apiDateFormat),
  activeTime: '',
  activeTimeBarber: '',
  items: [],
  isFetching: false,
  updatedAt: null,
});

const initialState = new InitialState();

export default function timesReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_BARBER_AVAILABILITY:
      return state.set('items', []).set('updatedAt', Date.now());

    case REQUEST_BARBER_AVAILABILITY:
      return state.set('isFetching', true);

    case SET_ACTIVE_DAY:
      return state.set('activeDay', action.payload);

    case SET_ACTIVE_TIME:
      return state.set('activeTime', action.payload);

    case SET_ACTIVE_TIME_BARBER:
      return state.set('activeTimeBarber', action.payload);

    case RECEIVE_BARBER_AVAILABILITY: {
      if (isEmpty(action.payload)) return state.set('isFetching', false);

      return state.withMutations(s =>
        s.set('items', unionBy(state.items, action.payload, 'day'))
          .set('isFetching', false)
          .set('updatedAt', Date.now())
      );
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/times/reducer.js